import { Route, Routes } from 'react-router-dom';
import { adminRoutesConfig, superAdminRoutesConfig, customerRoutesConfig, publicRoutesConfig } from './routesConfig';
import ProtectedRoute from './components/Admin/ProtectedRoute';
import AdminLayout from './components/Admin/layout';
import SuperAdminProtectedRoute from './components/Super_Admin/ProtectedRoute';
import SuperAdminLayout from './components/Super_Admin/layout';
import CustomerProtectedRoute from './components/Guest/ProtectedRoute';
import CustomerLayout from './components/Guest/layout';

function renderRoutes(routes, persona) {
  return routes.map((route, idx) => {
    const Element = route.element;
    // Merge persona and any extra props
    const props = { ...(route.extraProps || {}), ...(persona ? { persona } : {}) };
    return (
      <Route key={idx} path={route.path} element={<Element {...props} />} />
    );
  });
}

const AppRoutes = () => (
  <Routes>
    {renderRoutes(publicRoutesConfig)}

    <Route element={<ProtectedRoute />}>
      <Route element={<AdminLayout />}>
        {renderRoutes(adminRoutesConfig, "admin")}
      </Route>
    </Route>

    <Route element={<SuperAdminProtectedRoute />}>
      <Route element={<SuperAdminLayout />}>
        {renderRoutes(superAdminRoutesConfig, "super-admin")}
      </Route>
    </Route>

    <Route element={<CustomerProtectedRoute />}>
      <Route element={<CustomerLayout />}>
        {renderRoutes(customerRoutesConfig, "customer")}
      </Route>
    </Route>
  </Routes>
);

export default AppRoutes;